// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-draft-loading--H33Z5{position:absolute;bottom:0;left:0;right:0}.video-draft-loading--H33Z5 .progress-bar{height:8px;border-radius:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-draft-loading": "video-draft-loading--H33Z5"
};
export default ___CSS_LOADER_EXPORT___;
